import env from "../../utils/env";
import common from "../../utils/common";

let BotManagerService = function (HttpService) {
  "ngInject";

  const getDataSource = (successCb, errorCb) => {
    const dataSource = new kendo.data.DataSource({
      transport: {
        read: {
          url: env.getApiUrl("bigfoot/bots/search"),
          contentType: "application/json",
          type: "POST",
          beforeSend: _onBeforeSend,
        },
        update: {
          url: _getResourceLocation,
          contentType: "application/json",
          type: "PATCH",
          beforeSend: _onBeforeSend,
        },
        create: {
          url: env.getApiUrl("bigfoot/bots/create"),
          contentType: "application/json",
          type: "POST",
          beforeSend: _onBeforeSend,
        },
        parameterMap: _parameterMap
      },
      change: successCb,
      error: errorCb,
      schema: {
        data: "data",
        total: "total",
        model: {
          id: "id",
          fields: {
            "id": {type: "string"},
            "title": {type: "string", validation: { required: true }},
            "flowStatus": {type: "number", defaultValue: 0, validation: { required: true }},
            "flowFileBinary": {},
            "creationDate": { type: "date", editable: false}
          }
        }
      },
      serverFiltering: true,
      serverPaging: true,
      serverSorting: true,
      pageSize: 50
    })

    return dataSource;
  }

  return { getDataSource };
}

function _getResourceLocation(options) {
  return env.getApiUrl(`bigfoot/bots/${options.id}`);
}

function _onBeforeSend(req) {
  var token = `Bearer ${window.localStorage.getItem("bigfootAccessToken")}`;

  req.setRequestHeader("Authorization", token);
}

function _parameterMap(data, type) {
  if (type == "read" || type == "create") {
    let filters = [];

    if (data.filter) filters = data.filter.filters;

    let query = Object.assign({}, { filters: filters }, data)
    delete query.filter;

    console.log("Query::", query)

    return JSON.stringify(query);
  }

  if (type == "update") {

    // Dates used in the DataSource are JavaScript Date objects.
    // Therefore convert the date to utc before sending to remove dateoffset.

    //data.expireDate = common.converToUtcDate(data.expireDate);
    //data.startDate = common.converToUtcDate(data.startDate);

    console.log("update data", data);

    return JSON.stringify(data);
  }
}

export default BotManagerService;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/services/bot-manager.service.js
 **/